<template>
  <b-row>
    <b-col cols="12" xl="12">  
      <b-card>
        <template slot="header">
          Listado de Cheques Terceros - {{ tituloFecha }}
        </template> 
        <b-table 
            class="registro"
            responsive
            :no-border-collapse="true"
            :busy="tableBusy"
            :items="resultados" 
            :fields="fields"
            :current-page="paginaActual"
            :per-page="registrosPorPagina">
          <div slot="table-busy" class="text-center">
            <b-spinner class="table-spinner" label="Spinning" />
          </div>
          <template v-slot:cell(fechaPago)="data">
              {{ data.item.fechaPago | fecha }}
          </template>
          <template v-slot:cell(fechaEmision)="data">
              {{ data.item.fechaEmision | fecha }}
          </template>
          <template v-slot:cell(importe)="data">
            {{ data.item.importe | moneda }}
          </template>
        </b-table>
        <nav>
          <b-pagination size="sm" 
            :total-rows="totalRegistros" 
            :per-page="registrosPorPagina" 
            v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
        </nav>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'flujoFondos/getField',
  mutationType: 'flujoFondos/updateField',
});

export default {
  name: 'FlujoFondosChequesTerceros',
  props: {
    fechaResultados: {
      type: String,
      default: ''
    }
  },
  data: () => {
    return {
      fields: [
        { 
          key: 'fechaEmision',
          label: 'Fecha Emisión'
        },
        { 
          key: 'fechaPago',
          label: 'Fecha Pago'
        },
        { key: 'cliente' },
        {
          key: 'numero',
          class: 'text-right',
        },
        {
          key: 'importe',
          class: 'text-right',
        }
      ],
      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'resultados',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
    ]),
    tituloFecha() {
      return moment(this.fechaResultados).format('DD/MM/YYYY');
    }
  },
}
</script>

<style>
</style>
